let development_base_urls = {
    TEST_PLAYER_BASE_URL_8080:
        'https://3xs4jse3rc.execute-api.ap-south-1.amazonaws.com/dev/java2',
    SSO_LOGIN_URL: 'http://13.127.159.89:8081/ssoAuthentication',
    AMAZON_URL: 'https://anthe-kell-cms.aakash.ac.in',
    AMAZON_S3_URL: 'https://testcontent-dev.aakash.ac.in',
    AAKASH_PREVIEW_BASE_URL:
        'https://lcmsapi-dev.aakash.ac.in/dev/java/8086/test_player/api',
    TEST_PLAYER_BASE_URL_8086:
        'https://lcmsapi-dev.aakash.ac.in/dev/java/8086/test_player/api',
    QUESTION_ASSETS_URL: 'https://d2j0qxttzr723b.cloudfront.net',
    // development urls are yet to be updated, currently we're using stage/prod urls
    ANTHE_API_BASE_URL: 'https://antheapi-qa.aakash.ac.in/api',
    DASHBOARD_URL: 'https://anthedashboard-qa.aakash.ac.in',
    TEST_PLAYER_BASE_URL_8082:
        'https://testplayerapi-qa.aakash.ac.in/stage/test_analytics',
    CAPTCHA: 'https://testplayerapi-qa.aakash.ac.in/stage/captcha',
    TEST_SUBMIT: 'https://testplayerapi-qa.aakash.ac.in/stage/testplayer-submit',
    VALIDATE_OTP: 'https://mstimetable-prod.aakash.ac.in/api/validateotp',
    TEST_PLAYER_URLS: [
        'testplayerapi-qa.aakash.ac.in',
        '13.127.159.89:8086',
        'lcmsapi-dev.aakash.ac.in',
    ],
    ANTHE_DASHBOARD_LOGIN_URL: 'https://anthe-kell.aakash.ac.in/exam/login',
    // We haven't configured recaptcha for this env hence this is empty
    RECAPTCHA_SITE_KEY: '',
    RECAPTCHA_SITE_THRESHOLD: 0.5,
    IACST_RESULT_REDIRECT_URL: 'https://uat-new-iacst.aakash.ac.in/dashboard',
    IACST_LOGIN_URL: 'https://uat-new-iacst.aakash.ac.in/iacst',
}

let staging_base_urls = {
    TEST_PLAYER_BASE_URL_8080:
        'https://3xs4jse3rc.execute-api.ap-south-1.amazonaws.com/dev/java2',
    SSO_LOGIN_URL: 'http://13.127.159.89:8081/ssoAuthentication',
    AMAZON_URL: 'http://anthe-kell-cms.aakash.ac.in',
    TEST_PLAYER_BASE_URL_8086:
        'https://agtxshf3la.execute-api.ap-south-1.amazonaws.com/v1/test_player',
    TEST_PLAYER_BASE_URL_8082:
        'https://agtxshf3la.execute-api.ap-south-1.amazonaws.com/v1/test_analytics',
    TEST_SUBMIT:
        'https://agtxshf3la.execute-api.ap-south-1.amazonaws.com/v1/testplayer-submit',
    QUESTION_ASSETS_URL: 'https://d2j0qxttzr723b.cloudfront.net',
    ANTHE_DASHBOARD_LOGIN_URL: 'https://anthe-kell.aakash.ac.in/exam/login',
    // We haven't configured recaptcha for this env hence this is empty
    RECAPTCHA_SITE_KEY: '',
    RECAPTCHA_SITE_THRESHOLD: 0.01,
    IACST_RESULT_REDIRECT_URL: 'https://uat-new-iacst.aakash.ac.in/dashboard',
    IACST_LOGIN_URL: 'https://uat-new-iacst.aakash.ac.in/iacst',
}

let production_base_url = {
    TEST_PLAYER_BASE_URL_8080:
        'https://3xs4jse3rc.execute-api.ap-south-1.amazonaws.com/dev/java2',
    SSO_LOGIN_URL: 'http://13.127.159.89:8081/ssoAuthentication',
    AMAZON_URL: 'https://anthe-cms.aakash.ac.in',
    AMAZON_S3_URL: 'https://testcontent.aakash.ac.in',
    AAKASH_PREVIEW_BASE_URL:
        'https://testplayerapi-prod.aakash.ac.in/Prod/test_player',
    TEST_PLAYER_BASE_URL_8086:
        'https://testplayerapi-prod.aakash.ac.in/Prod/test_player',
    TEST_PLAYER_BASE_URL_8082:
        'https://testplayerapi-prod.aakash.ac.in/Prod/test_analytics',
    TEST_SUBMIT: 'https://testplayerapi-prod.aakash.ac.in/Prod/testplayer-submit',
    QUESTION_ASSETS_URL: 'https://d2j0qxttzr723b.cloudfront.net',
    CAPTCHA: 'https://testplayerapi-prod.aakash.ac.in/Prod/captcha',
    VALIDATE_OTP: 'https://mstimetable-prod.aakash.ac.in/api/validateotp',
    DASHBOARD_URL: 'https://anthedashboard-prod.aakash.ac.in',
    TEST_PLAYER_URLS: ['testplayerapi-prod.aakash.ac.in'],
    ANTHE_DASHBOARD_LOGIN_URL: 'https://anthe.aakash.ac.in/exam/login',
    RECAPTCHA_SITE_KEY: '',
    RECAPTCHA_SITE_THRESHOLD: 0.5,
    IACST_RESULT_REDIRECT_URL: 'https://iacst.aakash.ac.in/dashboard',
    IACST_LOGIN_URL: 'https://iacst.aakash.ac.in/exam/login',
}

let qa_base_url = {
    TEST_PLAYER_BASE_URL_8080:
        'https://3xs4jse3rc.execute-api.ap-south-1.amazonaws.com/dev/java2',
    SSO_LOGIN_URL: 'http://13.127.159.89:8081/ssoAuthentication',
    AAKASH_PREVIEW_BASE_URL:
        'https://testplayerapi-qa.aakash.ac.in/stage/test_player',
    AMAZON_URL: 'https://anthe-kell-cms.aakash.ac.in',
    AMAZON_S3_URL: 'https://testcontent-stage.aakash.ac.in',
    TEST_PLAYER_BASE_URL_8086:
        'https://testplayerapi-qa.aakash.ac.in/stage/test_player',
    TEST_PLAYER_BASE_URL_8082:
        'https://testplayerapi-qa.aakash.ac.in/stage/test_analytics',
    TEST_SUBMIT: 'https://testplayerapi-qa.aakash.ac.in/stage/testplayer-submit',
    QUESTION_ASSETS_URL: 'https://d2j0qxttzr723b.cloudfront.net',
    CAPTCHA: 'https://testplayerapi-qa.aakash.ac.in/stage/captcha',
    VALIDATE_OTP: 'https://mstimetable-prod.aakash.ac.in/api/validateotp',
    DASHBOARD_URL: 'https://anthedashboard-qa.aakash.ac.in',
    TEST_PLAYER_URLS: ['testplayerapi-qa.aakash.ac.in'],
    ANTHE_DASHBOARD_LOGIN_URL: 'https://anthe-kell.aakash.ac.in/exam/login',
    RECAPTCHA_SITE_KEY: '',
    RECAPTCHA_SITE_THRESHOLD: 0.01,
    IACST_RESULT_REDIRECT_URL: 'https://uat-new-iacst.aakash.ac.in/dashboard',
    IACST_LOGIN_URL: 'https://uat-new-iacst.aakash.ac.in/iacst',
}

let test_player_development = {
    init: `${development_base_urls.TEST_PLAYER_BASE_URL_8086}/init`,
    login: `${development_base_urls.SSO_LOGIN_URL}/login`,
    getAPIToken: `${development_base_urls.AMAZON_BASE_URL}/oauth/token`,
    getUserDetail: `${development_base_urls.AMAZON_BASE_URL}/api/get-student-detail`,
    getTestList: `${development_base_urls.AMAZON_BASE_URL}/api/leadstepgetprofile`,
    getTestList2: `${development_base_urls.AMAZON_BASE_URL}/api/leadstepgetprofilev2`,
    getResultAPI: `${development_base_urls.AMAZON_BASE_URL}/api/get-branch-phone-no`,
    testDetail: `${development_base_urls.TEST_PLAYER_BASE_URL_8080}/test`,
    testInstructionsByShortCode: `${development_base_urls.TEST_PLAYER_BASE_URL_8086}/shortCode`,
    questionsData: `${development_base_urls.AMAZON_S3_URL}`,
    previewQuestionsData: `${development_base_urls.AAKASH_PREVIEW_BASE_URL}/testPreview`,
    startNewTest: `${development_base_urls.TEST_PLAYER_BASE_URL_8086}/v2/testStatus`,
    resumeTest: `${development_base_urls.TEST_PLAYER_BASE_URL_8086}/testStatus`,
    testDataSubmit: `${development_base_urls.TEST_SUBMIT}`,
    ssologin: `${development_base_urls.SSO_LOGIN_URL}/login`,
    updateSingleQuestion: `${development_base_urls.TEST_PLAYER_BASE_URL_8082}/userQuestionActionAnalytics`,
    getTabSwitchCount: `${development_base_urls.TEST_PLAYER_BASE_URL_8082}/userQuestionActionAnalytics/tabChange`,
    getTestStatus: `${development_base_urls.TEST_PLAYER_BASE_URL_8086}/allTestStatus?rollNos=`,
    getAttemptedQuestions: `${development_base_urls.TEST_PLAYER_BASE_URL_8082}/userQuestionActionAnalytics`,
    question_image_url: development_base_urls.QUESTION_ASSETS_URL,
    interimResult: `${development_base_urls.ANTHE_API_BASE_URL}/anthe-result-config-date`,
    getTokenForResultApi: `${development_base_urls.AMAZON_URL}/oauth/token`,
    getResultData: `${development_base_urls.AMAZON_URL}/api/get-branch-phone-no`,
    captcha: `${development_base_urls.CAPTCHA}`,
    validateOTP: `${development_base_urls.VALIDATE_OTP}`,
    dashboard: `${development_base_urls.DASHBOARD_URL}`,
    testplayerUrls: development_base_urls.TEST_PLAYER_URLS,
    antheDashboardLoginUrl: development_base_urls.ANTHE_DASHBOARD_LOGIN_URL,
    recaptchaSiteKey: development_base_urls.RECAPTCHA_SITE_KEY,
    recaptchaSiteThreshold: development_base_urls.RECAPTCHA_SITE_THRESHOLD,
    iacstResultRedirectURL: development_base_urls.IACST_RESULT_REDIRECT_URL,
    iacstLoginUrl: development_base_urls.IACST_LOGIN_URL,
}

let test_player_staging = {
    login: `${qa_base_url.SSO_LOGIN_URL}/login`,
    getAPIToken: `${qa_base_url.AMAZON_BASE_URL}/oauth/token`,
    getUserDetail: `${qa_base_url.AMAZON_BASE_URL}/api/get-student-detail`,
    getTestList: `${qa_base_url.AMAZON_BASE_URL}/api/leadstepgetprofile`,
    getTestList2: `${qa_base_url.AMAZON_BASE_URL}/api/leadstepgetprofilev2`,
    getResultAPI: `${qa_base_url.AMAZON_BASE_URL}/api/get-branch-phone-no`,
    testDetail: `${qa_base_url.TEST_PLAYER_BASE_URL_8080}/test`,
    testInstructionsByShortCode: `${qa_base_url.TEST_PLAYER_BASE_URL_8086}/shortCode`,
    questionsData: `${qa_base_url.AMAZON_S3_URL}`,
    previewQuestionsData: `${qa_base_url.TEST_PLAYER_BASE_URL_8086}/testPreview`,
    startNewTest: `${qa_base_url.TEST_PLAYER_BASE_URL_8086}/testStatus`,
    resumeTest: `${qa_base_url.TEST_PLAYER_BASE_URL_8086}/testStatus`,
    testDataSubmit: `${qa_base_url.TEST_SUBMIT}`,
    ssologin: `${qa_base_url.SSO_LOGIN_URL}/login`,
    getTestStatus: `${qa_base_url.TEST_PLAYER_BASE_URL_8086}/allTestStatus?rollNos=`,
    getAttemptedQuestions: `${qa_base_url.TEST_PLAYER_BASE_URL_8082}/userQuestionActionAnalytics`,
    updateSingleQuestion: `${qa_base_url.TEST_PLAYER_BASE_URL_8082}/userQuestionActionAnalytics`,
    getTabSwitchCount: `${qa_base_url.TEST_PLAYER_BASE_URL_8082}/userQuestionActionAnalytics/tabChange`,
    question_image_url: qa_base_url.QUESTION_ASSETS_URL,
    getTokenForResultApi: qa_base_url.AMAZON_URL,
    getResultData: `${qa_base_url.AMAZON_URL}/api/get-branch-phone-no`,
    interimResult: `https://anthe-kell-cms.aakash.ac.in/api/anthe-result-config-date`,
    antheDashboardLoginUrl: staging_base_urls.ANTHE_DASHBOARD_LOGIN_URL,
    recaptchaSiteKey: staging_base_urls.RECAPTCHA_SITE_KEY,
    recaptchaSiteThreshold: staging_base_urls.RECAPTCHA_SITE_THRESHOLD,
    iacstResultRedirectURL: staging_base_urls.IACST_RESULT_REDIRECT_URL,
    iacstLoginUrl: staging_base_urls.IACST_LOGIN_URL,
}

let test_player_production = {
    init: `${production_base_url.TEST_PLAYER_BASE_URL_8086}/init`,
    login: `${production_base_url.SSO_LOGIN_URL}/login`,
    getAPIToken: `${production_base_url.AMAZON_BASE_URL}/oauth/token`,
    getUserDetail: `${production_base_url.AMAZON_BASE_URL}/api/get-student-detail`,
    getTestList: `${production_base_url.AMAZON_BASE_URL}/api/leadstepgetprofile`,
    getTestList2: `${production_base_url.AMAZON_BASE_URL}/api/leadstepgetprofilev2`,
    getResultAPI: `${production_base_url.AMAZON_BASE_URL}/api/get-branch-phone-no`,
    testDetail: `${production_base_url.TEST_PLAYER_BASE_URL_8080}/test`,
    testInstructionsByShortCode: `${production_base_url.TEST_PLAYER_BASE_URL_8086}/shortCode`,
    questionsData: `${production_base_url.AMAZON_S3_URL}`,
    previewQuestionsData: `${production_base_url.TEST_PLAYER_BASE_URL_8086}/testPreview`,
    mockQuestionsData: `${production_base_url.TEST_PLAYER_BASE_URL_8086}/testId`,
    startNewTest: `${production_base_url.TEST_PLAYER_BASE_URL_8086}/v2/testStatus`,
    resumeTest: `${production_base_url.TEST_PLAYER_BASE_URL_8086}/testStatus`,
    testDataSubmit: `${production_base_url.TEST_SUBMIT}`,
    mockTestDataSubmit: `${production_base_url.TEST_PLAYER_BASE_URL_8082}/userQuestionActionAnalytics/submitTest`,
    ssologin: `${production_base_url.SSO_LOGIN_URL}/login`,
    getTestStatus: `${production_base_url.TEST_PLAYER_BASE_URL_8086}/allTestStatus?rollNos=`,
    getAttemptedQuestions: `${production_base_url.TEST_PLAYER_BASE_URL_8082}/userQuestionActionAnalytics`,
    updateSingleQuestion: `${production_base_url.TEST_PLAYER_BASE_URL_8082}/userQuestionActionAnalytics`,
    getTabSwitchCount: `${production_base_url.TEST_PLAYER_BASE_URL_8082}/userQuestionActionAnalytics/tabChange`,
    question_image_url: production_base_url.QUESTION_ASSETS_URL,
    getTokenForResultApi: `${production_base_url.AMAZON_URL}/oauth/token`,
    getResultData: `${production_base_url.AMAZON_URL}/api/get-branch-phone-no`,
    getAnalyticsData: `${production_base_url.TEST_PLAYER_BASE_URL_8082}/userQuestionActionAnalytics/analytics`,
    captcha: `${production_base_url.CAPTCHA}`,
    interimResult: `https://antheapi.aakash.ac.in/api/anthe-result-config-date`,
    validateOTP: `${production_base_url.VALIDATE_OTP}`,
    dashboard: `${production_base_url.DASHBOARD_URL}`,
    testplayerUrls: production_base_url.TEST_PLAYER_URLS,
    antheDashboardLoginUrl: production_base_url.ANTHE_DASHBOARD_LOGIN_URL,
    recaptchaSiteKey: production_base_url.RECAPTCHA_SITE_KEY,
    recaptchaSiteThreshold: production_base_url.RECAPTCHA_SITE_THRESHOLD,
    iacstResultRedirectURL: production_base_url.IACST_RESULT_REDIRECT_URL,
    iacstLoginUrl: production_base_url.IACST_LOGIN_URL,
}

let test_player_qa = {
    init: `${qa_base_url.TEST_PLAYER_BASE_URL_8086}/init`,
    login: `${qa_base_url.SSO_LOGIN_URL}/login`,
    getAPIToken: `${qa_base_url.AMAZON_BASE_URL}/oauth/token`,
    getUserDetail: `${qa_base_url.AMAZON_BASE_URL}/api/get-student-detail`,
    getTestList: `${qa_base_url.AMAZON_BASE_URL}/api/leadstepgetprofile`,
    getTestList2: `${qa_base_url.AMAZON_BASE_URL}/api/leadstepgetprofilev2`,
    getResultAPI: `${qa_base_url.AMAZON_BASE_URL}/api/get-branch-phone-no`,
    testDetail: `${qa_base_url.TEST_PLAYER_BASE_URL_8080}/test`,
    testInstructionsByShortCode: `${qa_base_url.TEST_PLAYER_BASE_URL_8086}/shortCode`,
    questionsData: `${qa_base_url.AMAZON_S3_URL}`,
    previewQuestionsData: `${qa_base_url.AAKASH_PREVIEW_BASE_URL}/testPreview`,
    mockQuestionsData: `${qa_base_url.TEST_PLAYER_BASE_URL_8086}/testId`,
    startNewTest: `${qa_base_url.TEST_PLAYER_BASE_URL_8086}/v2/testStatus`,
    resumeTest: `${qa_base_url.TEST_PLAYER_BASE_URL_8086}/testStatus`,
    testDataSubmit: `${qa_base_url.TEST_SUBMIT}`,
    mockTestDataSubmit: `${qa_base_url.TEST_PLAYER_BASE_URL_8082}/userQuestionActionAnalytics/submitTest`,
    ssologin: `${qa_base_url.SSO_LOGIN_URL}/login`,
    getTestStatus: `${qa_base_url.TEST_PLAYER_BASE_URL_8086}/allTestStatus?rollNos=`,
    getAttemptedQuestions: `${qa_base_url.TEST_PLAYER_BASE_URL_8082}/userQuestionActionAnalytics`,
    updateSingleQuestion: `${qa_base_url.TEST_PLAYER_BASE_URL_8082}/userQuestionActionAnalytics`,
    getTabSwitchCount: `${qa_base_url.TEST_PLAYER_BASE_URL_8082}/userQuestionActionAnalytics/tabChange`,
    question_image_url: qa_base_url.QUESTION_ASSETS_URL,
    getTokenForResultApi: `${qa_base_url.AMAZON_URL}/oauth/token`,
    getResultData: `${qa_base_url.AMAZON_URL}/api/get-branch-phone-no`,
    getAnalyticsData: `${qa_base_url.TEST_PLAYER_BASE_URL_8082}/userQuestionActionAnalytics/analytics`,
    captcha: `${qa_base_url.CAPTCHA}`,
    interimResult: `https://antheapi-qa.aakash.ac.in/api/anthe-result-config-date`,
    validateOTP: `${qa_base_url.VALIDATE_OTP}`,
    dashboard: `${qa_base_url.DASHBOARD_URL}`,
    testplayerUrls: qa_base_url.TEST_PLAYER_URLS,
    antheDashboardLoginUrl: qa_base_url.ANTHE_DASHBOARD_LOGIN_URL,
    recaptchaSiteKey: qa_base_url.RECAPTCHA_SITE_KEY,
    recaptchaSiteThreshold: qa_base_url.RECAPTCHA_SITE_THRESHOLD,
    iacstResultRedirectURL: qa_base_url.IACST_RESULT_REDIRECT_URL,
    iacstLoginUrl: qa_base_url.IACST_LOGIN_URL,
}

/**
 * Test preview cross-domain handshake.
 *
 * The CMS opens the player at /?test_id=<id> (no token in the URL) and hands
 * over the tp_preview_token via postMessage once the player signals
 * PLAYER_READY. `cmsOrigins` is the allow-list of origins the player will
 * accept that token from and post PLAYER_READY to - anything else is ignored.
 *
 * `previewWithCredentials` sends the preview data request with credentials so
 * the HttpOnly CMS_AUTH cookie (Domain=.aakash.ac.in) rides along and the
 * backend can verify that the signed-in staff user may view this test.
 *
 * It is off everywhere for now: the testPreview endpoint answers with
 * `Access-Control-Allow-Origin: *`, which browsers reject outright on a
 * credentialed request, so turning it on blocks the call entirely. Flip it back
 * on per environment once the API echoes the caller's origin and sends
 * `Vary: Origin`. Override for a single run with
 * REACT_APP_PREVIEW_WITH_CREDENTIALS=true.
 *
 * Locally, override the allow-list with REACT_APP_CMS_ORIGINS (comma separated).
 */
const cms_handshake = {
    development: {
        cmsOrigins: ['https://content-staging.aakash.ac.in'],
        previewWithCredentials: false,
    },
    qa: {
        cmsOrigins: ['https://content-staging.aakash.ac.in'],
        previewWithCredentials: false,
    },
    staging: {
        cmsOrigins: ['https://content-staging.aakash.ac.in'],
        previewWithCredentials: false,
    },
    production: {
        cmsOrigins: ['https://content.aakash.ac.in'],
        previewWithCredentials: false,
    },
}

let config = {}

if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    config = test_player_production
} else if (process.env.REACT_APP_ENVIRONMENT === 'staging') {
    config = test_player_staging
} else if (process.env.REACT_APP_ENVIRONMENT === 'qa') {
    config = test_player_qa
} else if (process.env.REACT_APP_ENVIRONMENT === 'development') {
    config = test_player_development
}

config = {
    ...config,
    ...(cms_handshake[process.env.REACT_APP_ENVIRONMENT] || {}),
}

if (process.env.REACT_APP_PREVIEW_WITH_CREDENTIALS) {
    config.previewWithCredentials =
        process.env.REACT_APP_PREVIEW_WITH_CREDENTIALS === 'true'
}

if (process.env.REACT_APP_CMS_ORIGINS) {
    config.cmsOrigins = process.env.REACT_APP_CMS_ORIGINS.split(',')
        .map((origin) => origin.trim())
        .filter(Boolean)
}

export default config
